export default {
  consent: {
    title: 'We value your privacy',
    descriptionStart: 'We use tracking technologies to improve your experience and analyze how you use our service. By clicking "Accept", you consent to our use of these technologies. Read our ',
    privacyLinkText: 'Privacy Policy',
    descriptionEnd: ' for more details.',
    accept: 'Accept',
    decline: 'Decline',
  }
}